import { DEFAULT_TIERED_MIN, StripePriceInfo } from "@Containers/web-portal/utils/stripe";
import { CouponResponse, StripeSubscriptionDetails, StripeSubscriptionPrice } from "@Shared/schemas/stripe/stripeSchemas";

export interface TieredPricing {
  flat_amount: number | null;
  unit_amount: number | null;
  min: number | null;
  max: number | null;
}

export interface PaymentContextType {
  purchasePriceId: string | undefined;
  billingCountry: string;
  billingComplete: boolean;
  currencyUnavailable: boolean;
  setBillingCountry: (country: string) => void;
  setBillingComplete: (complete: boolean) => void;
  selectedPriceId: string | undefined;
  selectedPriceInfo: StripePriceInfo | undefined;
  finalPrice: number;
  basePrice: number;
  tieredPricing: TieredPricing | undefined;
  prices: StripeSubscriptionPrice[];
  paymentDetails: {
    amount: number;
    currency: string;
  };
  coupon: CouponResponse | undefined;
  promoCode: string;
  promoCodeError: string;
  promoCodeLoading: boolean;
  isLoading: boolean;
  productSelectionDialogOpen: boolean;
  incompleteSubscription: StripeSubscriptionDetails | null;
  quantity: number;

  applyPromoCode: (param: { promoCode?: string; couponId?: string }) => void;
  setSelectedPriceState: (priceId: string) => void;
  setProductSelectionDialogOpen: (open: boolean) => void;
  setQuantity: (quantity: number) => void;
  openOutstandingInvoiceDialog: () => void;
}

export const defaultState: PaymentContextType = {
  purchasePriceId: undefined,
  billingCountry: "",
  billingComplete: false,
  currencyUnavailable: false,
  setBillingCountry: () => {},
  setBillingComplete: () => {},
  selectedPriceId: undefined,
  selectedPriceInfo: undefined,
  basePrice: 0,
  finalPrice: 0,
  tieredPricing: undefined,
  prices: [],
  paymentDetails: { amount: 0, currency: "" },
  coupon: undefined,
  promoCode: "",
  promoCodeError: "",
  promoCodeLoading: false,
  isLoading: false,
  productSelectionDialogOpen: false,
  incompleteSubscription: null,
  quantity: DEFAULT_TIERED_MIN,

  applyPromoCode: (param: { promoCode?: string; couponId?: string }) => {},
  setSelectedPriceState: (priceId: string) => {},
  setProductSelectionDialogOpen: (open: boolean) => {},
  setQuantity: (quantity: number) => {},
  openOutstandingInvoiceDialog: () => {},
};
